/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'star': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M7.329 7.123l-4.85.692-.094.021a.545.545 0 00-.216.915l3.51 3.36-.829 4.746-.008.088a.559.559 0 00.82.49l4.337-2.241 4.34 2.242.082.035c.39.13.802-.195.729-.614l-.83-4.747 3.51-3.359.064-.071a.548.548 0 00-.373-.865l-4.85-.692-2.17-4.317a.563.563 0 00-1.002 0l-2.17 4.317zM10 4.29l1.798 3.579.058.09c.088.113.217.19.363.21l4.02.572-2.909 2.787-.07.082a.54.54 0 00-.09.404l.686 3.933-3.596-1.857-.1-.04a.572.572 0 00-.42.04l-3.597 1.857.687-3.933.008-.107a.542.542 0 00-.168-.379L3.76 8.74l4.02-.572a.56.56 0 00.422-.3L10 4.288z" _fill="#01B9CA" fill-rule="evenodd"/>'
  }
})
